export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./footer.vue?vue&type=template&id=278c512f&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footer.vue?vue&type=template&id=278c512f&scoped=true&
// module id = 112
// module chunks = 16